// Avisos rojos puestos a mano en reservas concretas (mismo aspecto que el de
// Overbooking). Se buscan por el código que enseña la ficha: el de la OTA o, si
// no hay, el de WACheckin. Para quitar uno, se borra su línea.
//
// HMARD2AZDS (Airbnb, Apartamento Bastian Casas Verdes, cuenta lymholidaysl@gmail.com):
// aviso de prueba pedido el 29-oct-2026 para validar cómo se ve.
export const AVISOS_POR_RESERVA = {
  HMARD2AZDS: {
    titulo: "Esta reserva entró en un periodo bloqueado",
    texto: "Razón: Bloqueo Maria Mettelli · Bastian 5. Contacta con tu channel manager, porque puede ser un problema de sincronización.",
  },
};

export function avisoDeReserva(reserva) {
  if (!reserva) return null;
  const codigos = [reserva.ota_code, reserva.codigo_reserva]
    .filter(Boolean)
    .map((c) => String(c).trim().toUpperCase());
  const clave = codigos.find((c) => AVISOS_POR_RESERVA[c]);
  return clave ? AVISOS_POR_RESERVA[clave] : null;
}
